import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { CATEGORY_LABELS } from "../lib/constants";

// A single bordered slab: black header bar, then rank blocks stacked under it.
export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="sticky top-24 border-[3px] border-foreground bg-surface shadow-card">
            <div className="flex items-center gap-2.5 border-b-[3px] border-foreground bg-foreground px-4 py-3">
                <Flame size={15} strokeWidth={3} className="text-accent" />
                <h4 className="eyebrow text-accent">Trending Now</h4>
            </div>
            <ol>
                {items.map((a, i) => (
                    <li key={a.id} className="border-b-2 border-foreground last:border-b-0">
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-4 p-4 hover:bg-accent-soft transition-colors duration-150"
                        >
                            <span className="font-display text-lg leading-none w-9 h-9 shrink-0 grid place-items-center border-2 border-foreground bg-accent text-accent-foreground tabular-nums group-hover:bg-foreground group-hover:text-accent transition-colors duration-150">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="min-w-0">
                                <span className="eyebrow !text-[10px] text-dim">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-sans text-sm font-bold leading-snug mt-1.5 text-foreground">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-dim p-4">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
